import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  QueryNewNotificationsRequest,
  ViewAllNotificationsRequest,
  ViewNewNotificationsRequest
} from './notification.types';

import {
  requestQueryNewNotifications,
  requestViewAllNotifications,
  requestViewNewNotifications
} from './notification.actions';

export const useNotificationApi = () => {
  const dispatch = useDispatch();

  const viewAllNotifications = useCallback(
    (requestData: ViewAllNotificationsRequest, onSuccess?: () => void) => {
      dispatch(requestViewAllNotifications({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const queryNewNotifications = useCallback(
    (requestData: QueryNewNotificationsRequest, onSuccess?: (data: boolean) => void) => {
      dispatch(requestQueryNewNotifications({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewNewNotifications = useCallback(
    (requestData: ViewNewNotificationsRequest, onSuccess?: () => void) => {
      dispatch(requestViewNewNotifications({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return { viewAllNotifications, queryNewNotifications, viewNewNotifications };
};
